"use client"

import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { ChevronRight, Home } from "lucide-react"

export type BreadcrumbItem = {
  label: string
  href?: string
}

type BreadcrumbProps = {
  items: BreadcrumbItem[]
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  if (!items || items.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-gray-500">
        <li className="flex items-center">
          <LocalizedClientLink
            href="/"
            className="hover:text-gray-900 transition-colors flex items-center gap-1"
          >
            <Home size={14} />
            <span>Home</span>
          </LocalizedClientLink>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <ChevronRight size={14} className="text-gray-300" />
            {item.href && index < items.length - 1 ? (
              <LocalizedClientLink
                href={item.href}
                className="hover:text-gray-900 transition-colors"
              >
                {item.label}
              </LocalizedClientLink>
            ) : (
              <span className="text-gray-900 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumb
